export default __webpack_public_path__ + "static/11.02-2789851219c99f0038f8d43358570f08.png";